import TitleExp from './title-exp.vue'
import Icon from './icon-prefix.vue'
import RagIcon from './rag-icon.vue'
import PageFoot from './page-foot.vue'
import FileButton from './file-import-button.vue'
import LoadingBar from './loading-bar.vue'
import LoadingData from './loading-data.vue'

export default {
   TitleExp,
   Icon,
   RagIcon,
   PageFoot,
   FileButton,
   LoadingBar,
   LoadingData,
}